export default __webpack_public_path__ + "static/media/basic.81369714.svg";